import request from '@/utils/request';

// 设备列表
export function ApiDeviceList(query) {
  return request({
    url: '/lock/gmwebapi/deviceList',
    method: 'get',
    params: query,
  });
}

// 设备删除
export function ApiDeviceDelete(query) {
  return request({
    url: '/lock/gmwebapi/deleteDevice/' + query,
    method: 'delete',
  });
}

// 设备新增
export function ApiDeviceAdd(query) {
  return request({
    url: '/lock/gmwebapi/addDevice',
    method: 'post',
    data: query,
  });
}

// 设备导入
export function ApiDeviceImport(query) {
  return process.env.VUE_APP_BASE_API + '/lock/gmwebapi/importDevice';
}
